import { Component, OnInit } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  dataList: any;
  selectedData = "";
  sm_Name = ""
  title: string;
  data: any;
  result: any = { result: false, RtnItem: {} };

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.dataList = this.data;
  }


  enter_Ok() {
    if (this.selectedData) {
      this.result.result = true;
      this.result.RtnItem = this.selectedData;
      this.close();
    }
  }

  selectList(i) {
    this.selectedData = i;
  }

}
